import { render } from "./loginpage.vue?vue&type=template&id=2475cb66&scoped=true"
import script from "./loginpage.vue?vue&type=script&lang=js"
export * from "./loginpage.vue?vue&type=script&lang=js"

import "./loginpage.vue?vue&type=style&index=0&id=2475cb66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2475cb66"]])

export default __exports__